// var links = document.links;
// for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
//   if (links[i].hostname !== window.location.hostname) {
//     links[i].target = '_blank';
//     links[i].rel = 'noreferrer noopener';
//   }
// }




      let lastOpenedAccordion = null;
    
      document.querySelectorAll('.accordion').forEach((accordion) => {
        accordion.addEventListener('click', () => {
          const clickedAccordionExpanded = accordion.getAttribute('aria-expanded') === 'true';
    
          if (lastOpenedAccordion && lastOpenedAccordion !== accordion) {
            console.log("Closing last opened accordion.");
            lastOpenedAccordion.setAttribute('aria-expanded', 'false');
            const lastOpenedAccordionContent = lastOpenedAccordion.querySelector('.accordion__content');
            lastOpenedAccordionContent.style.opacity = 0;
            lastOpenedAccordionContent.style.transform = 'translateY(0px)';
          }
    
          if (!clickedAccordionExpanded) {
            console.log("Expanding clicked accordion.");
            accordion.setAttribute('aria-expanded', 'false');
            const accordionContent = accordion.querySelector('.accordion__content');
            accordionContent.style.opacity = 1;
            accordionContent.style.transform = 'translateY(0px)';
          }
    
          // Update the lastOpenedAccordion variable
          lastOpenedAccordion = accordion;
        });
      });








